import React from "react";

const StockCreateSupplierScreen = () => {
  return <div>StockCreateSupplierScreen</div>;
};

export default StockCreateSupplierScreen;
